import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'endereco',
})
export class EnderecoPipe implements PipeTransform {
  constructor() {}

  transform(value: any, hideComplemento: boolean = false) {
    var result = '';

    if (value.paisNome && value.paisNome != 'BRASIL') {
      return value.formatado;
    }

    if (!value) {
      return '';
    }

    if (value.logradouro && value.numero) {
      result = value.logradouro + ' ' + value.numero;
    } else if (value.logradouro && !value.numero) {
      result = value.logradouro;
    } else if (!value.logradouro && value.numero) {
      result = value.numero;
    }

    if (value.bairro) {
      if (result) {
        result = result + ' - ';
      }
      result = result + value.bairro;
    }

    if (value.cep) {
      if (result) {
        result = result + ' - ';
      }
      result = result + value.cep;
    }

    if (value.cidadeNome) {
      if (result) {
        result = result + ', ';
      }
      result = result + value.cidadeNome + ' - ' + value.estadoSigla;
    }

    if (value.complemento && !hideComplemento) {
      result = result + ' - ' + value.complemento;
    }

    if (!result) {
      result = '--';
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/endereco/endereco.ts